import { useEffect, useState } from "react";
import Footer from "../../components/layout/footer";
import Header from "../../components/layout/header";
import Banner from "../../components/search/banner";
import MachineList from "../../components/search/machineList";
import FilterSidebar from "../../components/search/silterSidebar";
import { ApplicationId } from "../../api/url";
import { GetPagedWatchlistAssets, postMachinesList } from "../../services/FeaturedListings";
import { useLocation, useNavigate } from "react-router-dom";
import PageWrapper from "../../components/admin/layouts/PageWrapper/PageWrapper";
import InfiniteScroll from "react-infinite-scroll-component";
import CardSkeleton from "../../components/loader/skeleton/cardSkeleton";
import WatchListMachineList from "../../components/watchList/watchListMachineList";
import SidebarWatchListMachineList from "../../components/watchList/sidebarWatchListMachineList";
import { toast } from "react-toastify";
import { logoutFun } from "../../utils/helper";
import { useMsal } from "@azure/msal-react";

const WatchListSidebar = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { instance, accounts } = useMsal();
  const [isLoading, setIsLoading] = useState(false);
  const [isLazyLoading, setIsLazyLoading] = useState(false);
  const [machineData, setMachineData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [reload, setReload] = useState(false);

  const [additionalFilters, setAdditionalFilters] = useState({
    PageSize: 9,
    PageNumber: 1,
  });

  const azureUserInfo = localStorage.getItem("getAzureUserData")
    ? JSON.parse(localStorage.getItem("getAzureUserData") || {})
    : null;

  // Fetch machine list whenever filters change
  useEffect(() => {
    if (!isLoading) {
      GetMachinesList(additionalFilters);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [additionalFilters, reload]);

  const GetMachinesList = (Filters) => {
    if (parseInt(additionalFilters?.PageNumber) == 1) {
      setIsLoading(true);
    } else {
      setIsLazyLoading(true);
    }
    let payload = {
      Filter: { CompanyIds: [Number(azureUserInfo?.CompanyId)], active: true },
      PageNumber: Filters?.PageNumber,
      PageSize: Filters?.PageSize,
      IncludeCount: true,
      Sort: "ChangeDate_desc",
    };
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };

    GetPagedWatchlistAssets(payload, header, instance, accounts)
      .then((res) => {
        const showImgList = res?.data?.map((item) => ({
          ...item,
          image: item?.PrimaryImage?.url,
          caption: `<div class="bg-[#000] responsive_text_field" style="background: rgba(0,0,0,0.5); width: 90%; margin: auto; text-align:right; padding:0px 10px ">
                    ${item?.Year}&nbsp;&nbsp;&nbsp;${item?.Model}&nbsp;&nbsp;&nbsp;${item?.MakeName} -  Click for Details
                  </div>`,
          id: item?.AssetId,
          assetAdvertisementId: item?.AssetAdvertisementId,
          name: item?.PrimaryImage?.name.replaceAll(" ", "-"),
        }));

        const xPagination = JSON.parse(res.headers.get("x-pagination"));
        setTotalRecords(xPagination?.TotalRecords || 0);
        setMachineData(showImgList || []);

        if (parseInt(additionalFilters?.PageNumber) == 1) {
          setMachineData(showImgList);
        } else {
          setMachineData([...machineData, ...showImgList]);
        }

        setIsLazyLoading(false);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setIsLoading(false);
        setIsLazyLoading(false);
        if (err?.status == 401 || err?.statusText == "Unauthorized") {
          toast.error("you are logged out, login again to add machines to watchlist.");
          logoutFun(instance);
        } else {
          toast.error(err?.data);
        }
      });
  };

  const handelReload = () => {
    setAdditionalFilters({
      ...additionalFilters,
      PageSize: 12,
      PageNumber: 1,
    });
    setReload(!reload);
  };
  return (
    <div className="grid grid-cols-1 w-full">
      <div className="col-span-1 max-h-[90svh] overflow-y-auto custom-scrollbar pr-[10px]" id="scrollableTarget">
        <InfiniteScroll
          dataLength={machineData.length}
          next={() =>
            totalRecords >= machineData?.length
              ? setAdditionalFilters({
                  ...additionalFilters,
                  PageNumber: additionalFilters.PageNumber + 1,
                })
              : null
          }
          hasMore={true}
          loader={null}
          scrollableTarget="scrollableTarget"
        >
          <SidebarWatchListMachineList
            isLoading={isLoading}
            machineData={machineData}
            totalRecords={totalRecords}
            showRecord={additionalFilters.PageSize}
            currentPage={additionalFilters.PageNumber}
            setCurrentPage={(value) => {
              setAdditionalFilters({
                ...additionalFilters,
                PageNumber: value,
              });
            }}
            handelReload={handelReload}
          />
        </InfiniteScroll>

        {isLazyLoading && (
          <div className="grid grid-cols-1 gap-6 mt-[30px]">
            {[1, 2, 3].map(() => {
              return <CardSkeleton />;
            })}
          </div>
        )}
      </div>
    </div>
  );
};
export default WatchListSidebar;
